import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";
import loadData from "./data";
import FullPageLoader from "@Components/FullPageLoader";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import getBlogHomeData from "./data/getBlogHomeData";
import type { AppState } from "@Store/index";
import { getBlogLanguageFromPath } from "../utils/blogLanguage";

const BlogHome = loadable(() => import("./BlogHome"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { readyStatus, homeFeaturedBlogs } = useSelector((state: AppState) => state.blogHomeData);

  useEffect(() => {
    // Load data on client-side navigation if not already loaded or if data is empty
    if (
      readyStatus === "invalid" ||
      (readyStatus !== "request" && readyStatus !== "failure" && homeFeaturedBlogs.length === 0)
    ) {
      const lang = getBlogLanguageFromPath(location.pathname);
      dispatch(getBlogHomeData({ staticContext: props?.staticContext, lang }));
    }
  }, [dispatch, readyStatus, homeFeaturedBlogs.length, location.pathname]);

  return (
    <ErrorBoundary>
      <BlogHome {...props} />
    </ErrorBoundary>
  );
};

export { BlogHome as PreFetchBlogHome };
export { loadData };
